import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AddToCart, BuyNow } from 'src/app/shop';

@Injectable({
  providedIn: 'root',
})
export class CartActionsGuard  {
  constructor(private router: Router, private store: Store) {}

  canActivate(next: ActivatedRouteSnapshot) {
    const { id, quantity } = next.queryParams;
    const amount = parseInt(quantity);

    if (id) {
      this.store.dispatch(AddToCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: amount || 1 }] }));
      return this.router.parseUrl('/cart');
    }

    const { addToCartLine } = next.params;
    if (addToCartLine && addToCartLine.split(':')?.length === 2) {
      const [id, quantity] = addToCartLine.split(':');
      const amount = parseInt(quantity || '0');

      // TODO buynow
      this.store.dispatch(BuyNow({ lines: [{ variantId: 'gid://shopify/ProductVariant/' + id, quantity: amount }] }));
    }

    return true;
  }
}
